module.exports = __webpack_public_path__ + "img/zl_zj_bg.c44ca8b5.png";